import { render, staticRenderFns } from "./Meeting.SpeakerBtn.vue?vue&type=template&id=1951acbe&scoped=true"
import script from "./Meeting.SpeakerBtn.vue?vue&type=script&lang=js"
export * from "./Meeting.SpeakerBtn.vue?vue&type=script&lang=js"
import style0 from "./Meeting.SpeakerBtn.vue?vue&type=style&index=0&id=1951acbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1951acbe",
  null
  
)

export default component.exports